import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled(Group)`
  min-width: 50%;
  height: 100%;

  ${mediaQueryUp.tablet} {
    min-width: unset;
    height: unset;
  }
`

function StatisticTrustIndicator() {
  const intl = useIntl()

  return (
    <Container direction="vertical-reverse" horizontalAlign="center" verticalAlign="center" gap={4}>
      <Heading variant="heading3" align="center">{intl.formatMessage({
        id: '9q17CpnlW_Li7fytta-D',
        defaultMessage: '8 million members',
        description: 'Heading showing total member count in trust indicator',
      })}
      </Heading>
      <BodyText colour="light-foreground-alt" variant="medium" align="center">{intl.formatMessage({
        id: 'qpYdWgtdmj15PjY6xyKD',
        defaultMessage: 'Trusted by',
        description: 'Label above member count in trust indicator on the homepage',
      })}
      </BodyText>
    </Container>
  )
}

export default StatisticTrustIndicator
